export const initialState = {
    infoUsuario: '',
    tipoProcedimientos: '',
    procedimientoActual: '',
    convocatoriaSeleccionada: '',
    solicitudColaborativa: '',
    perfilSeleccionado: '',
    origenLogin: '',
    flagAvisosCriticos: '',
    misTramites: '',
    misTramitesVphone: '',
    resourceFormNuevaSolicitud: '',
    solicitudActual: '',
    pdfSolicitud: '',
    recibi: '',
    numRegistroAries: '',
    fase: '',
    estado: '',
    protectedRoute: '',
    convocatoriasProcedimientoPCT: '',
    urlProcedenciaProcedimiento: '',
    faseEstadoExpediente: '',
    loginOut: '',
    accesoBandejaSol: '',
    numeroExpediente: '',
    idExpediente: '',
    accionModificar: '',
    idFase: '',
    idEstadoFase: '',
    entidadSeleccionada: '',
    entidadesDeAlta: '',
    accion: '',
    organismo: '',
    modBajaRADA:''
}